import { useId } from 'react';

/** A labelled row of mutually exclusive buttons — the sides and format pickers. */
export function SegmentedChoice<T extends string>({
  label,
  options,
  active,
  onPick,
}: {
  label: string;
  options: { value: T; label: string }[];
  active: T;
  onPick: (value: T) => void;
}) {
  const labelId = useId();
  return (
    <div>
      <p id={labelId} className="mb-1 block text-xs font-medium text-ink">
        {label}
      </p>
      <div
        role="group"
        aria-labelledby={labelId}
        className="flex w-fit gap-0.5 bg-ink/5 p-0.5"
      >
        {options.map((o) => (
          <button
            key={o.value}
            type="button"
            aria-pressed={active === o.value}
            onClick={() => onPick(o.value)}
            className="px-4 py-1.5 text-xs font-medium transition-colors"
            style={
              active === o.value
                ? { background: 'var(--card)', color: 'var(--ink)' }
                : { background: 'transparent', color: 'var(--muted)' }
            }
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
